export default {
    baseUrl: {
        dev: '//readapi.bluebirdabc.com',
        pro: '//readapi.bluebirdabc.com'
    }
}